!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define("ReactMailForm", ["react"], t) : "object" == typeof exports ? exports.ReactMailForm = t(require("react")) : e.ReactMailForm = t(e.react);
}(this, function (e) {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        n.d(r, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 0);
  }([function (e, t, n) {
    "use strict";

    var _r,
        o = this && this.__extends || (_r = function r(e, t) {
      return (_r = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        a = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = a(n(1)),
        u = function (e) {
      function t(t) {
        var n = e.call(this, t) || this;
        n.state = {
          title: "",
          contents: ""
        }, n.handleTitle = function (e) {
          n.setState({
            title: e.target.value
          });
        }, n.handleContents = function (e) {
          n.setState({
            contents: e.target.value
          });
        };
        var r = n.props.to;
        if (!/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(r)) throw new Error("Invalid email address");
        return n;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this.props,
            t = e.to,
            n = e.className,
            r = void 0 === n ? "" : n,
            o = e.titleMaxLength,
            a = void 0 === o ? 50 : o,
            u = e.titlePlaceholder,
            l = void 0 === u ? "Title..." : u,
            c = e.contentsRows,
            s = void 0 === c ? 8 : c,
            f = e.contentsMaxLength,
            d = void 0 === f ? 500 : f,
            p = e.contentsPlaceholder,
            h = void 0 === p ? "Contents..." : p,
            m = e.buttonText,
            v = void 0 === m ? "Send E-mail" : m,
            y = this.state,
            b = y.title,
            _ = y.contents;
        return i.default.createElement("div", {
          className: r
        }, i.default.createElement("input", {
          type: "email",
          value: b,
          onChange: this.handleTitle,
          maxLength: Number(a),
          placeholder: l
        }), i.default.createElement("textarea", {
          value: _,
          onChange: this.handleContents,
          rows: Number(s),
          maxLength: Number(d),
          placeholder: h
        }), i.default.createElement("a", {
          href: "mailto:" + t + "?subject=" + b + "&body=" + _.replace(/\n/g, "%0D%0A")
        }, v));
      }, t;
    }(i.default.Component);

    t.default = u;
  }, function (t, n) {
    t.exports = e;
  }]);
});